import { render, staticRenderFns } from "./BeigeHintBar.vue?vue&type=template&id=2fec50d9&scoped=true&"
import script from "./BeigeHintBar.vue?vue&type=script&lang=js&"
export * from "./BeigeHintBar.vue?vue&type=script&lang=js&"
import style0 from "./BeigeHintBar.vue?vue&type=style&index=0&id=2fec50d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec50d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
